import { toBuildingSelectItem } from '../../../../Building'
import {
  DOC_FLOW_ENTITY_FIELD_BUILDING,
  DOC_FLOW_ENTITY_FIELD_BUILDING_GROUP,
  DOC_FLOW_FORM_FIELD_BUILDING_GROUPS,
  DOC_FLOW_FORM_FIELD_BUILDINGS,
} from '../../../DocFlow.constants'

function toScopeSelectItem(item) {
  return item ? toBuildingSelectItem(item) : null
}

export function getDocFlowProfileHeaderEditBuildingScopeInitialValues(docFlow) {
  return {
    [DOC_FLOW_FORM_FIELD_BUILDING_GROUPS]: toScopeSelectItem(
      docFlow?.[DOC_FLOW_ENTITY_FIELD_BUILDING_GROUP]
    ),
    [DOC_FLOW_FORM_FIELD_BUILDINGS]: toScopeSelectItem(
      docFlow?.[DOC_FLOW_ENTITY_FIELD_BUILDING]
    ),
  }
}
